import { render, staticRenderFns } from "./detail-logisticscost.vue?vue&type=template&id=08ed62b3&scoped=true"
import script from "./detail-logisticscost.vue?vue&type=script&lang=ts"
export * from "./detail-logisticscost.vue?vue&type=script&lang=ts"
import style0 from "./detail-logisticscost.vue?vue&type=style&index=0&id=08ed62b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed62b3",
  null
  
)

export default component.exports